let menuItems = document
    .querySelector(".header__inline-menu")
    .querySelectorAll("details");

for (const menuItem of menuItems) {
    let timeout;

    menuItem.addEventListener("mouseenter", () => {
        clearTimeout(timeout);
        menuItem.setAttribute("open", true);
    });

    menuItem.addEventListener("mouseleave", () => {
        timeout = setTimeout(() => {
            menuItem.removeAttribute("open");
        }, 200); // Retraso de 200ms
    });

    const submenu = menuItem.querySelector("ul");
    if (submenu) {
        submenu.addEventListener("mouseenter", () => {
            clearTimeout(timeout);
        });

        submenu.addEventListener("mouseleave", () => {
            timeout = setTimeout(() => {
                menuItem.removeAttribute("open");
            }, 200); // Retraso de 200ms
        });
    }
}